import Utils from '../../Utils';
import {Parameter} from './Parameter';
import {fieldOptions} from './PrequalXref';

class PrequalParameter extends Parameter {
    valueAsString = () => {
        return fieldOptions.hasOwnProperty(this.id)
            ? (fieldOptions[this.id as keyof typeof fieldOptions].options
                  .find((o) => Utils.MakeVarName(o) === this.value)
                  ?.toString() ?? this.value.toString())
            : this.value.toString();
    };
}

export class Prequal {
    incomeIndividual: Parameter = new PrequalParameter('incomeIndividual');
    isCurrentlyMilitary: Parameter = new PrequalParameter('isCurrentlyMilitary');
    currentDeploymentOrders: Parameter = new PrequalParameter('currentDeploymentOrders');
    isUSCitizen: Parameter = new PrequalParameter('isUSCitizen');
    usCitizenship: Parameter = Object.assign(new PrequalParameter('usCitizenship'), {name: 'usCitizenship'});
    usVisaType: Parameter = new PrequalParameter('usVisaType');
    insuranceNeeds: Parameter = new PrequalParameter('insuranceNeeds');
    firstName: Parameter = new PrequalParameter('firstName');
    lastName: Parameter = new PrequalParameter('lastName');
    middleName: Parameter = new PrequalParameter('middleName');
    suffix: Parameter = new PrequalParameter('suffix');
    bmonth: Parameter = new PrequalParameter('bmonth', '1');
    bday: Parameter = new PrequalParameter('bday', '1');
    byear: Parameter = new PrequalParameter('byear', '2021');
    age: Parameter = new PrequalParameter('age');
    gender: Parameter = new PrequalParameter('gender', 'Male');
    state: Parameter = new PrequalParameter('state');
    maritalStatus: Parameter = new PrequalParameter('maritalStatus');
    kids: Parameter = new PrequalParameter('kids');
    kidsNumber: Parameter = new PrequalParameter('kidsNumber');
    moreQuestions1: Parameter = new PrequalParameter('moreQuestions1');
    tobacco: Parameter = new PrequalParameter('tobacco');
    healthConditions: Parameter = new PrequalParameter('healthConditions');
    tobaccoUsage: Parameter = new PrequalParameter('tobaccoUsage');
    tobaccoUsageDate: Parameter = new PrequalParameter('tobaccoUsageDate');
    tobaccoMethod: Parameter = new PrequalParameter('tobaccoMethod');
    otherHealthConditions: Parameter = new PrequalParameter('otherHealthConditions');
    height: Parameter = new PrequalParameter('height', '64');
    weight: Parameter = new PrequalParameter('weight', '180');
    DrugorAlcoholDependenceWithdrawal: Parameter = new PrequalParameter('DrugorAlcoholDependenceWithdrawal');
    DrugorAlcoholDependenceWithdrawalTreatmentStatus: Parameter = new PrequalParameter(
        'DrugorAlcoholDependenceWithdrawalTreatmentStatus',
    );
    DrugorAlcoholDependenceWithdrawalTreatmentDate: Parameter = new PrequalParameter(
        'DrugorAlcoholDependenceWithdrawalTreatmentDate',
    );
    DUI: Parameter = new PrequalParameter('DUI');
    DUIDate: Parameter = new PrequalParameter('DUIDate');
    License: Parameter = new PrequalParameter('License');
    suspendedLicense: Parameter = new PrequalParameter('suspendedLicense');
    Movingviolations: Parameter = new PrequalParameter('Movingviolations');
    Criminaloffense: Parameter = new PrequalParameter('Criminaloffense');
    criminalOffenseDate: Parameter = new PrequalParameter('criminalOffenseDate');
    criminalOffenseChargeType: Parameter = new PrequalParameter('criminalOffenseChargeType');
    criminalOffenseProbation: Parameter = new PrequalParameter('criminalOffenseProbation');
    Bankruptcy: Parameter = new PrequalParameter('Bankruptcy');
    bankruptcyOpen: Parameter = new PrequalParameter('bankruptcyOpen');
    HIV: Parameter = new PrequalParameter('HIV');
    extremeSports: Parameter = new PrequalParameter('extremeSports');
    livingAssistance: Parameter = new PrequalParameter('livingAssistance');
    currentlyEmployed: Parameter = new PrequalParameter('currentlyEmployed');
    currentSelfEmployed: Parameter = new PrequalParameter('currentSelfEmployed');
    nameOfEmployer: Parameter = new PrequalParameter('nameOfEmployer');
    timeEmployed: Parameter = new PrequalParameter('timeEmployed');
    employmentDays: Parameter = new PrequalParameter('employmentDays');
    employerAddress: Parameter = new PrequalParameter('employerAddress');
    occupation: Parameter = new PrequalParameter('occupation');
    industryDuties: Parameter = new PrequalParameter('industryDuties');
    prevSelfEmployed: Parameter = new PrequalParameter('prevSelfEmployed');
    prevEmployName: Parameter = new PrequalParameter('prevEmployName');
    prevEmployStart: Parameter = new PrequalParameter('prevEmployStart');
    prevEmployOccup: Parameter = new PrequalParameter('prevEmployOccup');
    prevEmployIndustry: Parameter = new PrequalParameter('prevEmployIndustry');
    reasonUnemployed: Parameter = new PrequalParameter('reasonUnemployed');
    previousJobInfo: Parameter = new PrequalParameter('previousJobInfo');
    previousIncome: Parameter = new PrequalParameter('previousIncome');
    retiredInfo: Parameter = new PrequalParameter('retiredInfo');
    retiredIncome: Parameter = new PrequalParameter('retiredIncome');
    schoolInfo: Parameter = new PrequalParameter('schoolInfo');
    disabilityInfo: Parameter = new PrequalParameter('disabilityInfo');
    otherInfo: Parameter = new PrequalParameter('otherInfo');
    monthlyBudget: Parameter = new PrequalParameter('monthlyBudget');
    recommendedCoverageAmount: Parameter = new PrequalParameter('recommendedCoverageAmount');
    incomeHouseholdText: Parameter = new PrequalParameter('incomeHouseholdText');
    existingCoverage: Parameter = new PrequalParameter('existingCoverage');
    existingPolicyType: Parameter = new PrequalParameter('existingPolicyType', 'Unknown');
    existingCarrier: Parameter = new PrequalParameter('existingCarrier');
    existingCoverageAmount: Parameter = new PrequalParameter('existingCoverageAmount');
    policyNumber: Parameter = new PrequalParameter('policyNumber');
    accidentalDeathBenefitAmount: Parameter = new PrequalParameter('accidentalDeathBenefitAmount');
    howLongInforce: Parameter = new PrequalParameter('howLongInforce');
    behavioralRisks: Parameter = new PrequalParameter('behavioralRisks');
    replacingExistingPolicy: Parameter = new PrequalParameter('replacingExistingPolicy');
    shoppedCoverage: Parameter = new PrequalParameter('shoppedCoverage');
    shoppedPolicyType: Parameter = new PrequalParameter('shoppedPolicyType');
    shoppedCarrier: Parameter = new PrequalParameter('shoppedCarrier');
    shoppedCoverageAmount: Parameter = new PrequalParameter('shoppedCoverageAmount');
    policyEverBeenDeclined: Parameter = new PrequalParameter('policyEverBeenDeclined');
    notes: Parameter = new PrequalParameter('notes');

    intentFocus: Parameter = new PrequalParameter('intentFocus');
    intentFunding: Parameter = new PrequalParameter('intentFunding');
    intentBenefitStart: Parameter = new PrequalParameter('intentBenefitStart');

    recommendedProductPrimary: Parameter = new PrequalParameter('recommendedProductPrimary');
    recommendedProductFallback: Parameter = new PrequalParameter('recommendedProductFallback');
    recommendedProductFallbackTriggers: Parameter = new PrequalParameter('recommendedProductFallbackTriggers');
    recommendedProductPrimaryScript: Parameter = new PrequalParameter('recommendedProductPrimaryScript');
    recommendedProductFallbackScript: Parameter = new PrequalParameter('recommendedProductFallbackScript');
    recommendedProductIneligibleForOriginalRecommendations: Parameter = new PrequalParameter(
        'recommendedProductIneligibleForOriginalRecommendations',
    );
    selectedProduct: Parameter = new PrequalParameter('selectedProduct');
    pivotReason: Parameter = new PrequalParameter('pivotReason');
    pivotOtherReason: Parameter = new PrequalParameter('pivotOtherReason');
    recommendedProductCode: Parameter = new PrequalParameter('recommendedProductCode');
    recommendedFallbackProductCode: Parameter = new PrequalParameter('recommendedFallbackProductCode');
    selectedProductCode: Parameter = new PrequalParameter('selectedProductCode');
    userOverriddenSelection: Parameter = new PrequalParameter('userOverriddenSelection');
    hasSelectedProduct: Parameter = new PrequalParameter('hasSelectedProduct', false);

    static isRequiredField(key: string) {
        return [
            'firstName',
            'lastName',
            'bmonth',
            'bday',
            'byear',
            'gender',
            'state',
            'tobacco',
            'healthConditions',
            'height',
            'weight',
            'HIV',
            'extremeSports',
            'livingAssistance',
            'currentSelfEmployed',
            'nameOfEmployer',
            'timeEmployed',
            'employerAddress',
            'occupation',
            'industryDuties',
            'prevSelfEmployed',
            'prevEmployName',
            'prevEmployStart',
            'prevEmployOccup',
            'prevEmployIndustry',
            'reasonUnemployed',
            'previousJobInfo',
            'previousIncome',
            'retiredInfo',
            'retiredIncome',
            'schoolInfo',
            'disabilityInfo',
            'monthlyBudget',
        ].includes(key);
    }
}
